<template>
    <div>
        <buttonlist
                @add="add"
                @reflash="reflash"
                @exps="exps"
                @del="del"
                @print="print"
                @save="save"
                ref="SetBtn"
        ></buttonlist>
        <div>
            <div style="display: flex">
                <div>
                    <table>
                        <tr>
                            <td style="width:120px;min-width:100px"></td>
                            <td style="width:120px;min-width:100px"></td>
                            <td style="width:120px;min-width:100px"></td>
                            <td style="width:120px;min-width:100px">
                                <div class="pztitle">会计年度</div>
                                <el-input v-model="templateHead['会计年度']" type="number" size="mini" :disabled="!iscaneditothervouch || isEdit==1"></el-input>
                            </td>
                            <td style="width:120px;min-width:100px">
                                <div class="pztitle">会计期间</div>
                                <el-input v-model="templateHead['会计期间']" type="number" size="mini" :disabled="!iscaneditothervouch || isEdit==1"></el-input>
                            </td>
                            <td style="width:120px;min-width:100px">
                                <div class="pztitle">制单日期</div>
                                <el-date-picker
                                        v-model="templateHead['制单日期']"
                                        type="date"
                                        value-format="yyyy/MM/dd"
                                        style="width:100%" :disabled="!iscaneditvouch">
                                </el-date-picker>
                            </td>
                            <td style="width:120px;min-width:100px">
                                <div class="pztitle">凭证类别</div>
                                <el-input v-model="templateHead['凭证类别']"  size="mini" :disabled="true"></el-input>
                            </td>
                            <td style="width:120px;min-width:100px">
                                <div class="pztitle">凭证编号</div>
                                <el-input v-model="templateHead['凭证编号']" type="number" size="mini" :disabled="true"></el-input>
                            </td>
                            <td style="width:120px;min-width:100px">
                                <div class="pztitle">附件张数</div>
                                <el-input v-model="templateHead['附件张数']" type="number" size="mini" :disabled="!iscaneditvouch"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <div class="pztitle">支付日期</div>
                                <el-date-picker
                                        v-model="templateHead['支付日期']"
                                        type="date"
                                        style="width:100%" :disabled="!iscaneditvouch">
                                </el-date-picker>
                            </td>
                            <td>
                                <div class="pztitle">支付方式</div>
                                <el-input  v-model="templateHead['支付方式']" type="text" size="mini" :disabled="!iscaneditvouch"></el-input>
                            </td>
                            <td>
                                <div class="pztitle">票号</div>
                                <el-input v-model="templateHead['票号']" type="number" size="mini" :disabled="!iscaneditvouch"></el-input>
                            </td>
                            <td>
                                <div class="pztitle">经手人</div>
                                <el-input v-model="templateHead['经手人']" type="text" size="mini" :disabled="!iscaneditvouch"></el-input>
                            </td>
                            <td>
                                <div class="pztitle">原始处理号</div>
                                <el-input v-model="templateHead['原始处理号']" type="number" size="mini" :disabled="!iscaneditvouch"></el-input>
                            </td>
                            <td>
                                <div class="pztitle">物料处理号</div>
                                <el-input v-model="templateHead['物料处理号']" type="number" size="mini" :disabled="!iscaneditvouch"></el-input>
                            </td>
                            <td>
                                <div class="pztitle">凭单号</div>
                                <el-input v-model="templateHead['凭单号']" type="number" size="mini" :disabled="!iscaneditvouch"></el-input>
                            </td>
                            <td>
                                <div class="pztitle">凭单序号</div>
                                <el-input v-model="templateHead['凭单序号']" type="number" size="mini" :disabled="!iscaneditvouch"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <div class="pztitle">备注</div>
                                <el-input v-model="templateHead['备注']" type="text" size="mini" :disabled="!iscaneditvouch"></el-input>
                            </td>
                            <td>
                                <div class="pztitle">收付类别</div>
                                <el-select  v-model="templateHead['收付类别']" size="mini" :disabled="!iscaneditvouch">
                                    <el-option v-for="item in reftypearr" :key="item.Code" :label="item.Name"
                                               :value="item.Code"></el-option>
                                </el-select>
                            </td>
                            <td>
                                <div class="pztitle">发票号</div>
                                <el-input v-model="templateHead['发票号']" type="text" size="mini" :disabled="!iscaneditvouch"></el-input>
                            </td>
                            <td>
                                <div class="pztitle">制单人</div>
                                <el-input v-model="templateHead['制单人']" type="text" size="mini" :disabled="true"></el-input>
                            </td>
                            <td>
                                <div class="pztitle">审核人</div>
                                <el-input v-model="templateHead['审核人']" type="text" size="mini" :disabled="true"></el-input>
                            </td>
                            <td>
                                <div class="pztitle">记帐人</div>
                                <el-input v-model="templateHead['记帐人']" type="text" size="mini" :disabled="true"></el-input>
                            </td>
                            <td>
                                <div class="pztitle">打印人</div>
                                <el-input v-model="templateHead['打印人']" type="text" size="mini" :disabled="true"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
                <div style="margin-left: 1%">
                    <el-checkbox v-model="styleData['资产']">资产</el-checkbox><br/>
                    <el-checkbox v-model="styleData['供货商']">供货商</el-checkbox><br/>
                    <el-checkbox v-model="styleData['客户']">客户</el-checkbox><br/>
                    <el-checkbox v-model="styleData['数量']">数量</el-checkbox><br/>
                    <el-checkbox v-model="styleData['外币']">外币</el-checkbox>
                </div>
            </div>
            <div>
                <el-table
                        :data="dataTemplate"
                        border
                        resizable
                        size="mini"
                        :height="tableHeight - 130"
                        ref="singleTablemb"
                        header-row-class-name="headerclass"
                        :header-cell-style="$limits.headerClass"
                        :auto-resize="true"
                        :highlight-current-row="false"
                        show-overflow="tooltip"
                        show-footer
                        :row-class-name="tableRowClassName"
                        @cell-click="handleCellClick"
                        :summary-method="getSummaries"
                        show-summary
                >
                    >
                    <el-table-column  prop="摘要" label="摘要" width="200" header-align="center">
                        <template slot-scope="scope">
                            <div style="height:100%;display: flex; align-items: center; gap: 2px;">
                            <el-input style="flex: 1;width:calc(100% - 15px - 2px)" type="text" size="mini" v-model="scope.row['摘要']" class="noborder"></el-input>
                            <el-button style="width:15px;border-radius: 2px;padding: 0px;height:100%;" @click.native="selectAbstract">...</el-button>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="会计科目" label="会计科目"  width="300" header-align="center">
                        <template slot-scope="scope">
                            <div style="height:100%;display: flex; align-items: center; gap: 2px;">
                            <el-input style="flex: 1;width:calc(100% - 15px - 2px)" v-model="scope.row['会计科目']" :rows="1" type="textarea" size="mini" class="noborder" @dblclick.native="selectSubject(scope)">
                                <!--<i class="el-icon-edit el-input__icon" slot="suffix" @click="selectSubject(scope)"></i>-->
                            </el-input>
                            <el-button style="width:15px;border-radius: 2px;padding: 0px;height:100%;" @click.native="selectSubject(scope)">...</el-button>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="固定资产" label="固定资产"  width="100" v-if="styleData['资产']" header-align="center">
                        <template slot-scope="scope">
                            <el-input type="text" size="mini" v-model="scope.row['固定资产']" class="noborder"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="供货商" label="供货商"  width="100" v-if="styleData['供货商']" header-align="center">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row['供货商']" type="text" size="mini" class="noborder" @dblclick.native="selectVend(scope)">
                                <!-- <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectVend(scope)"></i>-->
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="客户" label="客户"  width="100" v-if="styleData['客户']" header-align="center">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row['客户']" type="text" size="mini" class="noborder" @dblclick.native="selectCust(scope)">
                                <!--<i class="el-icon-edit el-input__icon" slot="suffix" @click="selectCust(scope)"></i>-->
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="单位码1" label="单位码1" width="100" header-align="center">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row['单位码1']" type="text" size="mini" class="noborder" @dblclick.native="selectUnitcd1(scope)">
                                <!--<i class="el-icon-edit el-input__icon" slot="suffix" @click="selectUnitcd1(scope)"></i>-->
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="单位码2" label="单位码2" width="100" header-align="center">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row['单位码2']" type="text" size="mini" class="noborder" @dblclick.native="selectUnitcd2(scope)">
                                <!--<i class="el-icon-edit el-input__icon" slot="suffix" @click="selectUnitcd2(scope)"></i>-->
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="单位码3" label="单位码3" width="100" header-align="center">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row['单位码3']" type="text" size="mini" class="noborder" @dblclick.native="selectUnitcd3(scope)">
                                <!--<i class="el-icon-edit el-input__icon" slot="suffix" @click="selectUnitcd3(scope)"></i>-->
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="单位码4" label="单位码4" width="100" header-align="center">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row['单位码4']" type="text" size="mini" class="noborder" @dblclick.native="selectUnitcd4(scope)">
                                <!--<i class="el-icon-edit el-input__icon" slot="suffix" @click="selectUnitcd4(scope)"></i>-->
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="数量" label="数量"  width="80" v-if="styleData['数量']" header-align="center">
                        <template slot-scope="scope">
                            <el-input type="text" size="mini" v-model="scope.row['数量']" class="noborder"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="单价" label="单价"  width="80" v-if="styleData['数量']" header-align="center">
                        <template slot-scope="scope">
                            <el-input type="text" size="mini" v-model="scope.row['单价']" class="noborder"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="币种" label="币种"  width="80" v-if="styleData['外币']" header-align="center">
                        <template slot-scope="scope">
                            <el-input type="text" size="mini" v-model="scope.row['币种']" class="noborder"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="外币" label="外币"  width="80" v-if="styleData['外币']" header-align="center">
                        <template slot-scope="scope">
                            <el-input type="text" size="mini" v-model="scope.row['外币']" class="noborder"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="汇率" label="汇率"  width="80" v-if="styleData['外币']" header-align="center">
                        <template slot-scope="scope">
                            <el-input type="text" size="mini" v-model="scope.row['汇率']" class="noborder"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="借方金额" label="借方金额" width="100" align="right" header-align="center">
                        <template slot-scope="scope">
                            <el-input type="number" @mousewheel.native.prevent size="mini" v-model="scope.row['借方金额']" @change="getAmount" :class="[scope.row['借方金额']<0 ? 'noborder_fontred' : 'noborder']"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="贷方金额" label="贷方金额" width="100" align="right" header-align="center">
                        <template slot-scope="scope">
                            <el-input type="number" @mousewheel.native.prevent size="mini" v-model="scope.row['贷方金额']" @change="getAmount" :class="[scope.row['贷方金额']<0 ? 'noborder_fontred' : 'noborder']"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- 完整科目名称 -->
        <!--<selector :isVisible="false" :isBatch=false :selectType="0" :isSplitPage="true"
                  :postUrl="'/Basic/Popup/GetSubjectPopuDataList'" @callback="getSubject" ref="subject"></selector>-->
        <subjecttable :isVisible="false" :isBatch=false :selectType="0" :isSplitPage="true"
                  :postUrl="'/Basic/Popup/GetSubjectPopuDataList'" @callback="getSubject" ref="subject"></subjecttable>
        <!-- 供应商 -->
        <selector :isVisible="false" :isBatch=false :selectType="0" :isSplitPage="true"
                  :postUrl="'/Basic/Popup/GetVendaddrMstPopuDataList'" @callback="getVend" ref="vend"></selector>
        <!-- 客户 -->
        <selector :isVisible="false" :isBatch=false :selectType="0" :isSplitPage="true"
                  :postUrl="'/Basic/Popup/GetCustaddrMstPopuDataList'" @callback="getCust" ref="cust"></selector>
        <!-- 单位码1 -->
        <selector :isVisible="false" :isBatch=false :selectType="0" :isSplitPage="true"
                  :postUrl="'/Basic/Popup/GetUnitcd1MstPopuDataList'" @callback="getUnitcd1" ref="unitcd1"></selector>
        <!-- 单位码2 -->
        <selector :isVisible="false" :isBatch=false :selectType="0" :isSplitPage="true"
                  :postUrl="'/Basic/Popup/GetUnitcd2MstPopuDataList'" @callback="getUnitcd2" ref="unitcd2"></selector>
        <!-- 单位码3 -->
        <selector :isVisible="false" :isBatch=false :selectType="0" :isSplitPage="true"
                  :postUrl="'/Basic/Popup/GetUnitcd3MstPopuDataList'" @callback="getUnitcd3" ref="unitcd3"></selector>
        <!-- 单位码4 -->
        <selector :isVisible="false" :isBatch=false :selectType="0" :isSplitPage="true"
                  :postUrl="'/Basic/Popup/GetUnitcd4MstPopuDataList'" @callback="getUnitcd4" ref="unitcd4"></selector>

        <el-dialog v-dialogDrag :visible.sync="visLoadVouch" :title="$t('getapi[30220]')" width="30%" :close-on-click-modal="false">
            <vxe-table
                    :data="dataSet"
                    v-loading="loading"
                    :row-class-name="tableRowClassName"
                    border
                    stripe
                    resizable
                    size="mini"
                    height="500"
                    ref="singleTable"
                    header-row-class-name="headerclass"
                    :header-cell-style="$limits.headerClass"
                    :auto-resize="true"
                    :highlight-current-row="true"
                    show-overflow="tooltip"
                    @cell-dblclick="confirmSelectVouch"
                    @cell-click="selectVouch"
            >
                <vxe-table-column show-overflow field="凭证名称" :title="$t('getapi[30045]')" width='100'/>
                <vxe-table-column show-overflow field="制单" :title="$t('getapi[30122]')" width='100'/>
            </vxe-table>
            <span slot="footer" class="dialog-footer">
				<el-button  size="small" @click="visLoadVouch = false">{{ $t('getapi[30503]') }}</el-button>
				<el-button  size="small" type="primary" @click="confirmSelectVouch">{{ $t('getapi[30221]') }}</el-button>
            </span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visCash" :title="titleCash" width="40%" :close-on-click-modal="false">
            <vxe-table
                    :data="dataCash"
                    border
                    stripe
                    resizable
                    size="mini"
                    :height="500"
                    ref="singleTablecash"
                    header-row-class-name="headerclass"
                    :header-cell-style="$limits.headerClass"
                    :auto-resize="true"
                    :highlight-current-row="true"
                    show-overflow="tooltip"
                    show-footer
                    @cell-click="clickcash"
            >
                >
                <vxe-table-column show-overflow field="现金流量名称" :title="$t('getapi[30142]')" width="400" header-align="center"></vxe-table-column>
                <vxe-table-column show-overflow field="方向" :title="$t('getapi[30305]')"  width="50" header-align="center"></vxe-table-column>
                <vxe-table-column show-overflow field="流入金额" :title="$t('getapi[30203]')" width="100" align="right" header-align="center">
                    <template scope="scope">
                        <el-input type="text" @mousewheel.native.prevent size="mini" v-model="scope.row['借方金额']" @change="getAmount"
                                  oninput="value=value.replace(/[^\d.]/g, '')
                   .replace(/^\./g, '')
                   .replace(/\.{2,}/g, '.')
                   .replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
                   .replace(/^(-)*(\d+)\.(\d{0,2}).*$/, '$1$2.$3')"></el-input>
                    </template>
                </vxe-table-column>
                <vxe-table-column show-overflow field="流出金额" :title="$t('getapi[30204]')" width="100" align="right" header-align="center">
                    <template scope="scope">
                        <el-input type="text" @mousewheel.native.prevent size="mini" v-model="scope.row['贷方金额']"
                                  oninput="value=value.replace(/[^\d.]/g, '')
                   .replace(/^\./g, '')
                   .replace(/\.{2,}/g, '.')
                   .replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
                   .replace(/^(-)*(\d+)\.(\d{0,2}).*$/, '$1$2.$3')"></el-input>
                    </template>
                </vxe-table-column>
            </vxe-table>
            <span slot="footer" class="dialog-footer">
				<el-button  size="small" @click="visCash = false">{{ $t('getapi[30503]') }}</el-button>
                <el-button  size="small" type="primary" @click="autoFill">{{ $t('getapi[30205]') }}</el-button>
				<el-button  size="small" type="primary" @click="saveCash">{{ $t('getapi[30504]') }}</el-button>
            </span>
        </el-dialog>

        <subject :isVisible="false" ref="subjecttree" @callback="getSubjectTree"></subject>

        <abstract :isVisible="false" ref="abstract" @callback="getAbstract"></abstract>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { mapState, mapGetters, mapActions } from 'vuex';
    import {Message, MessageBox} from 'element-ui';
    export default {
        computed:{
            ...mapState(['keyboardEventStack']),
            ...mapGetters(['currentKeyboardEventTarget']),
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        name:'vouch',
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('vouch'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                selectData: [], //勾选合集
                isShowEdit: false,
                scrollTop:0,
                vouchtype:'',//新建时凭证类别
                templateHead:{
                    会计年度:'',
                    会计期间:'',
                    制单日期:'',
                    凭证类别:'',
                    凭证编号:'',
                    附件张数:'',
                    支付日期:'',
                    支付方式:'',
                    票号:'',
                    经手人:'',
                    原始处理号:'',
                    物料处理号:'',
                    凭单号:'',
                    凭单序号:'',
                    备注:'',
                    收付类别:'',
                    发票号:'',
                    制单人:'',
                    审核人:'',
                    记帐人:'',
                    打印人:'',
                },
                dataTemplate: [{
                    摘要:'',
                    会计科目:'',
                    固定资产:'',
                    供货商:'',
                    客户:'',
                    单位码1:'',
                    单位码2:'',
                    单位码3:'',
                    单位码4:'',
                    数量:'',
                    单价:'',
                    币种:'',
                    外币:'',
                    借方金额:'',
                    贷方金额:'',
                    支付日期:'',
                    支付方式:'',
                    票号:'',
                    经手人:'',
                    原始处理号:'',
                    物料处理号:'',
                    凭单号:'',
                    凭单序号:'',
                    收付类别:'',
                    发票号:'',
                }],//模板数据
                styleData:{
                    资产:'',
                    供货商:'',
                    客户:'',
                    数量:'',
                    外币:'',
                },
                iscontinuedblclick: true,
                vouchtypearr:[], // 凭证类别数组
                reftypearr:[],//收付类别数组
                selectIndex:0,//选中当前行的下标
                selectrow:{},//选中行
                visCash: false,//现金流量弹窗
                dataCash:[],//现金流量弹窗数据
                titleCash:'',//现金流量弹标题
                valCash:'',
                selectCashIndex:-1,//现金流量弹窗 选择当前行下标
                selectcashCell:'',//现金流量弹窗 选择当前单元格列名
                AccountFirstYear:'',
                AccountFirstMonth:'',
                isEdit:0,///是否新增0新增 1编辑
                visLoadVouch:false,//选择凭证模板弹窗
                keySelectIndex:'',//选择凭证模板行号
                currentRowIndex: 0, // 当前行索引
                currentColIndex: 0, // 当前列索引
                iscaneditvouch: false,//是否可以编辑系统凭证
                btn:{
                    addrow:false,//新增行
                    delrow:false,//删除行
                    readycash:false,//现金流量数据准备
                    balance:false,//自动找平
                    changelend:false,//借贷余额对调
                    copy:false,//复制
                    rollback:false,//红冲
                    passvouch:false,//审核
                    unpassvouch:false,//放弃审核
                },
                iscanpassvouch: false,//凭证审核
                iscanunpassvouch: false,//凭证取消审核
                iscaneditothervouch: false,//编辑其他会计期间凭证
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
            visLoadVouch(newVal){
                if(newVal){
                    this.openModal('modal_loadvouch')
                } else {
                    this.closeModal()
                }
            }
        },
        beforeDestroy(){
            let that = this
            window.removeEventListener('keydown',  e => this.handleKeyDown(e));
            removeEventListener('paste', that.keyPaste);
        },
        mounted: function() {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                console.log(form)
                if ((form.name == 'vouchbrowerfilter')) {
                    const data = [...vm.$store.state.sharedParamsArr];
                    console.log(data)
                    vm.getVouch(data);
                    vm.$store.commit('clearSharedParamsArr')
                }
            });
        },
        activated () {
            let that = this
            /*setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })*/
        },
        methods: {
            ...mapActions(['openModal', 'closeModal']),
            // 判断弹窗是否打开
            isModalOpen(modalId) {
                return this.keyboardEventStack.includes(modalId);
            },
            authority() {
                let that = this;
                that.$refs.SetBtn.SetButtonEnable('create,refresh,export,print');
                let userauthority = that.userData.Role_Lists.split(',')
                for(let i=0;i<userauthority.length;i++){
                    if(userauthority[i]=='凭证审核'){
                        that.iscanpassvouch = true
                    }
                    if(userauthority[i]=='凭证取消审核'){
                        that.iscanunpassvouch = true
                    }
                    if(userauthority[i]=='编辑其他会计期间凭证'){
                        that.iscaneditothervouch = true
                    }
                }
                console.log(that.iscanpassvouch)
                if(that.templateHead['审核人']=='' && that.templateHead['记帐人']=='' && that.iscanpassvouch){
                    that.btn.passvouch = true
                } else {
                    that.btn.passvouch = false
                }
                if(that.templateHead['审核人']!='' && that.templateHead['记帐人']=='' && that.iscanunpassvouch){
                    that.btn.unpassvouch = true
                } else {
                    that.btn.unpassvouch = false
                }
                that.iscaneditvouch = that.templateHead['审核人'].trim().length == 0 && that.templateHead['记帐人'].trim().length == 0
                let token = that.userData.token;
                $.ajax({
                    url: Common.Url + '/VouchBrower/IsSystemVouchType?token=' + token+'&VouchType='+that.$processdata.subStr(that.templateHead['凭证类别'],".",true),
                    type: 'post',
                    async: false,
                    contentType: 'application/json',
                    success: function (res) {
                        if (res.Success == 1) {
                            if(res.Key == 1){
                                that.iscaneditvouch = false
                            } else {
                                that.iscaneditvouch = true
                            }
                            if(that.iscaneditvouch && that.isEdit == 1){
                                that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            } else {
                                that.$refs.SetBtn.SetOneBtnEnable('del',false);
                            }

                            if(that.iscaneditvouch){
                                that.$refs.SetBtn.SetOneBtnEnable('save',true);
                                that.btn.addrow = true
                                that.btn.delrow = true
                                that.btn.creadycash = true
                                that.btn.balance = true
                                that.btn.changelend = true
                            } else {
                                that.$refs.SetBtn.SetOneBtnEnable('save',false);
                                that.btn.addrow = false
                                that.btn.delrow = false
                                that.btn.creadycash = false
                                that.btn.balance = false
                                that.btn.changelend = false
                                that.btn.copy = false
                                that.btn.rollback = false
                            }
                        } else {
                            //Message.error(res.Msg);
                        }
                    },
                    error: function (xhr, errorType, error) {
                    }
                });
            },
            tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
            },
            // 刷新
            reflash() {
                let that = this;
            },
            // 导出
            exps() {

            },
            del(){
                let that = this
                this.$confirm(that.$t('getapi[30507]'), that.$t('getapi[30508]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[30506]'),
                    cancelButtonText: that.$t('getapi[30503]'),
                    type: 'warning'
                })
                    .then(() => {
                        let str = ''
                        for(let i = 0;i<that.dataTemplate.length;i++){
                            str = str + that.dataTemplate[i]['序号'] + ','
                        }
                        str = str.substring(0,str.length-1)
                        let parm = {
                            ids: str,
                            LangType:that.$processdata.getLang()
                        }
                        that.$http.urlpost('/Vouch/DeleteVouchByID', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[30515]')
                        });
                    });
            },
            //根据凭证类别获取最大凭证编号
            getMaxVouchId(){
                let that = this
                let parm = {
                    year:localStorage.getItem('AccYear'),
                    month:localStorage.getItem('AccMonth'),
                    vouchtype:that.$processdata.subStr(that.templateHead['凭证类别'],'.',true)
                }
                that.$http.urlpost('/Vouch/getMaxVouchIdEx', parm, function(res) {
                    if (res.Success == 1) {
                        if(res.DataContent){
                            that.vouchtype = that.templateHead['凭证类别']
                            that.templateHead['凭证编号'] = parseInt(res.DataContent) + 1
                        }
                    }
                });
            },
            add(){
                let that = this
                let parm={
                    year:localStorage.getItem('AccYear'),
                    month:localStorage.getItem('AccMonth')
                }
                that.$http.urlpost('/Vouch/GetPeriodDay',parm , function(res) {
                    if (res.Success == 1) {
                        that.templateHead['支付日期'] = res.DataContent
                    }
                });
                that.confirmAdd()
            },
            confirmAdd(){
                let that = this
                that.isEdit = 0
                let vouchtype = '';
                let date = that.$processdata.getPeriodDay(localStorage.getItem('AccYear'),localStorage.getItem('AccMonth'))
                for(let i = 0;i<that.vouchtypearr.length;i++){
                    if(that.vouchtypearr[i].Name.indexOf("TJ") !== -1){
                        vouchtype = that.vouchtypearr[i].Name
                    }
                }
                vouchtype == ''?that.vouchtypearr[0].Name:vouchtype
                if(that.vouchtype == ''){
                    that.vouchtype = vouchtype
                }
                let parm = {
                    year:localStorage.getItem('AccYear'),
                    month:localStorage.getItem('AccMonth'),
                    vouchtype:that.vouchtype == ''?that.$processdata.subStr(that.vouchtypearr[0].Name,'.',true):that.$processdata.subStr(that.vouchtype,'.',true),
                }
                that.$http.urlpost('/Vouch/getMaxVouchIdEx', parm, function(res) {
                    if (res.Success == 1) {
                        if(res.DataContent){
                            that.templateHead = {
                                会计年度:localStorage.getItem('AccYear'),
                                会计期间:localStorage.getItem('AccMonth'),
                                制单日期:date,
                                凭证类别:that.vouchtype == ''?that.vouchtypearr[0].Name:that.vouchtype,
                                凭证编号:parseInt(res.DataContent) + 1,
                                附件张数:'',
                                支付日期:'',
                                支付方式:'',
                                票号:'',
                                经手人:'',
                                原始处理号:'',
                                物料处理号:'',
                                凭单号:'',
                                凭单序号:'',
                                备注:'',
                                收付类别:'',
                                发票号:'',
                                制单人:that.userData.Login_Name,
                                审核人:'',
                                记帐人:'',
                                打印人:'',
                                // "Text1Text": "", //打印人
                                // "Text9Text": "",//备注
                                // "Text4Text": "",//审核人
                                // "Text5Text": "",//记账人
                                // "Combo1Text": "",//凭证类别
                                // "TDBDate1Value": "",//制单日期
                                // "TDBNumber1Value": '',//凭证编号
                                // "TDBNumber2Value": '',//附件张数
                                // "TDBNumber3Value": localStorage.getItem('AccYear'),//会计年度
                                // "TDBNumber4Value": localStorage.getItem('AccMonth'),//会计期间
                                // "Image1Visible": true,
                            }
                        }
                    }
                });
                that.dataTemplate = []
                for(let i=0;i<20;i++){
                    that.dataTemplate = [...that.dataTemplate,{
                        摘要:'',
                        会计科目:'',
                        固定资产:'',
                        供货商:'',
                        客户:'',
                        单位码1:'',
                        单位码2:'',
                        单位码3:'',
                        单位码4:'',
                        数量:'',
                        单价:'',
                        币种:'',
                        外币:'',
                        借方金额:'',
                        贷方金额:'',
                    }]
                }
                that.authority()
            },
            save(){
                let that = this
                let arr = []
                for(let i=0;i<that.dataTemplate.length;i++){
                    if(that.dataTemplate[i]['会计科目'] != ''){
                        arr = [...arr,{
                            序号:'',
                            凭证序号:that.templateHead['会计年度'] + '.' + that.templateHead['会计期间'] + '/' + that.$processdata.subStr(that.templateHead['凭证类别'],'.',true)+'|'+that.templateHead['凭证编号'],

                            凭证索引号: that.$processdata.getVouchIndex(that.templateHead['会计年度'],that.templateHead['会计期间'],that.$processdata.subStr(that.templateHead['凭证类别'],".",true),that.templateHead['凭证编号']),
                            会计年度:that.templateHead['会计年度'],
                            会计期间:that.templateHead['会计期间'],
                            日期:that.templateHead['制单日期'],
                            凭证类别:that.$processdata.subStr(that.templateHead['凭证类别'],'.',true),
                            凭证编号:that.templateHead['凭证编号'],
                            附件:that.templateHead['附件张数'],
                            科目编码:'',
                            资产科目编码:'',
                            单位码1:that.dataTemplate[i]['单位码1'],
                            单位码2:that.dataTemplate[i]['单位码2'],
                            单位码3:that.dataTemplate[i]['单位码3'],
                            单位码4:that.dataTemplate[i]['单位码4'],
                            供货商编码:that.dataTemplate[i]['供货商'],
                            客户编码:that.dataTemplate[i]['客户'],
                            摘要:that.dataTemplate[i]['摘要'],
                            方向:that.$limits.fnIsEmpty(that.dataTemplate[i]['借方金额'])?'贷':'借',
                            单价:that.dataTemplate[i]['单价'],
                            借方数量:that.dataTemplate[i]['借方金额'] == 0?0:that.dataTemplate[i]['数量'],
                            贷方数量:that.dataTemplate[i]['借方金额'] == 0?that.dataTemplate[i]['数量']:0,
                            外币币种:that.dataTemplate[i]['币种'],
                            汇率:that.dataTemplate[i]['汇率'],
                            借方外币:that.dataTemplate[i]['借方金额'] == 0?0:that.dataTemplate[i]['外币'],
                            贷方外币:that.dataTemplate[i]['借方金额'] == 0?that.dataTemplate[i]['外币']:0,
                            "借方金额": that.dataTemplate[i]['借方金额'],
                            "贷方金额": that.dataTemplate[i]['贷方金额'],
                            支付日期:that.templateHead['支付日期'],
                            支付方式:that.templateHead['支付方式'],
                            票号:that.templateHead['票号'],
                            经手人:that.templateHead['经手人'],
                            原始处理号:that.templateHead['原始处理号'],
                            物料处理号:that.templateHead['物料处理号'],
                            凭单号:that.templateHead['凭单号'],
                            凭单序号:that.templateHead['凭单序号'],
                            收付类别:that.templateHead['收付类别'],
                            发票号:that.templateHead['发票号'],
                            制单:that.templateHead['制单人'],
                            审核:that.templateHead['审核人'],
                            记帐:that.templateHead['记帐人'],
                            打印:that.templateHead['打印人'],
                            反冲:false,
                            备注:that.templateHead['备注'],
                            RowPointer:'',
                            Company_Ref: that.userData.Site_Ref,
                            IsEdit: that.isEdit,
                            会计科目:that.dataTemplate[i]['会计科目'],
                            客户:that.dataTemplate[i]['客户'],
                            供货商: that.dataTemplate[i]['供货商'],
                            固定资产: that.dataTemplate[i]['固定资产'],
                            数量:that.dataTemplate[i]['数量'],
                            币种: that.dataTemplate[i]['币种'],
                            外币:that.dataTemplate[i]['外币']
                        }]
                    }
                }
                console.log(arr)
                for(let i=0;i<arr.length;i++){
                    if(arr[0]['摘要'] == ''){
                        that.$message.warning(this.$t('getapi[30568]'))
                        return false
                    } else {
                        if(arr[i]['摘要'] == ''){
                           arr[i]['摘要'] = arr[i-1]['摘要']
                        }
                    }
                    if(arr[i]['会计科目'] == ''){
                        that.$message.warning(this.$t('getapi[30581]'))
                        return false
                    }
                }
                let parm = {
                    Text1Text: that.templateHead['打印人'],
                    Text9Text: that.templateHead['备注'],
                    Text4Text: that.templateHead['审核人'],
                    Text5Text: that.templateHead['记帐人'],
                    Combo1Text: that.templateHead['凭证类别'],
                    TDBDate1Value: that.templateHead['制单日期'],
                    TDBNumber1Value: that.templateHead['凭证编号'],
                    TDBNumber2Value: that.templateHead['附件张数'],
                    TDBNumber3Value: that.templateHead['会计年度'],
                    TDBNumber4Value: that.templateHead['会计期间'],
                    Image1Visible:that.isEdit == 0?true:false,
                    list:arr
                }
                that.$http.urlpost('/Vouch/SaveVouch', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isEdit = 1
                        let parm = {
                            year: that.templateHead['会计年度'],
                            month: that.templateHead['会计期间'],
                            vouchtype:that.$processdata.subStr(that.templateHead['凭证类别'],'.',true),
                            vouchid:that.templateHead['凭证编号'],
                            type:3,
                        }
                        that.getVouch(parm)
                    }
                });
            },
            addLine(){
                let that = this
                that.dataTemplate = [...that.dataTemplate,{
                    摘要:'',
                    会计科目:'',
                    固定资产:'',
                    供货商:'',
                    客户:'',
                    单位码1:'',
                    单位码2:'',
                    单位码3:'',
                    单位码4:'',
                    数量:'',
                    单价:'',
                    币种:'',
                    外币:'',
                    汇率:'',
                    借方金额:'',
                    贷方金额:'',
                    序号:'',
                }]
            },
            delLine(){
                let that = this
                that.dataTemplate.splice(that.currentRowIndex, 1)
            },
            selectSubject(row){
                let that = this
                that.selectIndex = row.$index
                window.removeEventListener('keydown',  e => this.handleKeyDown(e));
                if(that.dataTemplate[that.selectIndex]['会计科目'] != ''){
                    that.$refs.subject.clearInputWithQuery(true,that.dataTemplate[that.selectIndex]['会计科目'].split('.')[0])
                } else {
                    that.$refs.subject.clearInput(true);
                }
            },
            selectSubject_(index){
                let that = this
                that.selectIndex = index
                window.removeEventListener('keydown',  e => this.handleKeyDown(e));
                if(that.dataTemplate[that.selectIndex]['会计科目'] != ''){
                    that.$refs.subject.clearInputWithQuery(true,that.dataTemplate[that.selectIndex]['会计科目'].split('.')[0])
                } else {
                    that.$refs.subject.clearInput(true);
                }
            },
            getSubject(data){
                let that = this
                console.log(data)
                that.closeModal()
                that.dataTemplate[that.selectIndex]['会计科目']=data['科目编码']+'.'+data['完整科目名称']
                that.dataTemplate[that.selectIndex]['币种']=data['外币币种']
                if(data['核算供货商'] == true){
                    that.styleData['供货商'] = true
                }
                if(data['核算客户'] == true){
                    that.styleData['客户'] = true
                }
                if( that.dataTemplate[that.selectIndex]['币种'] != ''){
                    that.styleData['外币'] = true
                    let parm = {
                        币种:that.dataTemplate[that.selectIndex]['币种']
                    }
                    that.$http.urlpost('/Vouch/GetTJCurrate', parm, function(res) {
                        if (res.Success == 1) {
                            that.dataTemplate[that.selectIndex]['汇率'] = res.Key
                        }
                    });
                }
            },
            selectVend(row){
                let that = this
                that.selectIndex = row.$index
                window.removeEventListener('keydown',  e => this.handleKeyDown(e));
                that.$refs.vend.clearInput(true);
            },
            selectVend_(index){
                let that = this
                that.selectIndex = index
                window.removeEventListener('keydown',  e => this.handleKeyDown(e));
                that.$refs.vend.clearInput(true);
            },
            getVend(data){
                let that = this
                that.closeModal()
                that.dataTemplate[that.selectIndex]['供货商编码'] = data.vend_num
                that.dataTemplate[that.selectIndex]['供货商名称'] =  data.name
                that.dataTemplate[that.selectIndex]['供货商']=data.vend_num +'.'+  data.name
            },
            selectCust(row){
                let that = this
                that.selectIndex = row.$index
                window.removeEventListener('keydown',  e => this.handleKeyDown(e));
                that.$refs.cust.clearInput(true);
            },
            selectCust_(index){
                let that = this
                that.selectIndex = index
                window.removeEventListener('keydown',  e => this.handleKeyDown(e));
                that.$refs.cust.clearInput(true);
            },
            getCust(data){
                let that = this
                that.closeModal()
                that.dataTemplate[that.selectIndex]['客户编码'] = data.vend_num
                that.dataTemplate[that.selectIndex]['客户名称'] =  data.name
                that.dataTemplate[that.selectIndex]['客户']=data.cust_num +'.'+ data.name
            },
            selectUnitcd1(row){
                let that = this
                that.selectIndex = row.$index
                window.removeEventListener('keydown',  e => this.handleKeyDown(e));
                that.$refs.unitcd1.clearInput(true);
            },
            selectUnitcd1_(index){
                let that = this
                that.selectIndex = index
                window.removeEventListener('keydown',  e => this.handleKeyDown(e));
                that.$refs.unitcd1.clearInput(true);
            },
            getUnitcd1(data){
                let that = this
                that.closeModal()
                that.dataTemplate[that.selectIndex]['单位码1']=data.unit1+'.'+data.description
            },
            selectUnitcd2(row){
                let that = this
                that.selectIndex = row.$index
                window.removeEventListener('keydown',  e => this.handleKeyDown(e));
                that.$refs.unitcd2.clearInput(true);
            },
            selectUnitcd2_(index){
                let that = this
                that.selectIndex = index
                window.removeEventListener('keydown',  e => this.handleKeyDown(e));
                that.$refs.unitcd2.clearInput(true);
            },
            getUnitcd2(data){
                let that = this
                that.closeModal()
                that.dataTemplate[that.selectIndex]['单位码2']=data.unit2+'.'+data.description
            },
            selectUnitcd3(row){
                let that = this
                that.selectIndex = row.$index
                window.removeEventListener('keydown',  e => this.handleKeyDown(e));
                that.$refs.unitcd3.clearInput(true);
            },
            selectUnitcd3_(index){
                let that = this
                that.selectIndex = index
                window.removeEventListener('keydown',  e => this.handleKeyDown(e));
                that.$refs.unitcd3.clearInput(true);
            },
            getUnitcd3(data){
                let that = this
                that.closeModal()
                that.dataTemplate[that.selectIndex]['单位码3']=data.unit3+'.'+data.description
            },
            selectUnitcd4(row){
                let that = this
                that.selectIndex = row.$index
                window.removeEventListener('keydown',  e => this.handleKeyDown(e));
                that.$refs.unitcd4.clearInput(true);
            },
            selectUnitcd4_(index){
                let that = this
                that.selectIndex = index
                window.removeEventListener('keydown',  e => this.handleKeyDown(e));
                that.$refs.unitcd4.clearInput(true);
            },
            getUnitcd4(data){
                let that = this
                that.closeModal()
                that.dataTemplate[that.selectIndex]['单位码4']=data.unit4+'.'+data.description
            },
            getSummaries(param) {
                let that = this
                const {columns, data} = param
                const sums = [];
                columns.forEach((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计'
                    } else if ('借方金额'.includes(column.property)) {
                        sums[columnIndex] =  this.sumNum(data, '借方金额')
                    } else if ('贷方金额'.includes(column.property)){
                        sums[columnIndex]  = this.sumNum(data, '贷方金额')
                    }  else {
                        sums[columnIndex] = ''
                    }
                })
                //that.$processdata.preciseRoundToTwo(total)
                return sums
            },
            sumNum(costForm, type) {
                if (type == '借方金额' || type == '贷方金额') {
                    let total = 0.0
                    for (let i = 0; i < costForm.length; i++) {
                        total = (total + parseFloat((costForm[i][type] == '' || undefined == costForm[i][type])?0:costForm[i][type] ))
                    }
                    total=Math.round(total * 10000) / 10000
                    return total.toString().replace(/\d+/, function(n){ // 先提取整数部分
                        return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                            return $1+",";
                        });
                    })
                }
            },
            getAmount(){
               let that = this
               that.dataTemplate = [...that.dataTemplate]
            },
            copyOrBack(type){
                let that = this
                that.isEdit = 0
                let parm = {
                    year: that.templateHead['会计年度'],
                    month: that.templateHead['会计期间'],
                    vouchtype:that.$processdata.subStr(that.templateHead['凭证类别'],'.',true),
                    vouchid:that.templateHead['凭证编号'],
                    type:type,
                }
                that.getVouch(parm)
            },
            //显示记账凭证
            getVouch(data){
                let that = this
                that.handleData(data)
            },
            //现金流量，显示凭证
            getFillVouch(param){
                let that = this
                that.isEdit = 1
                let parm = {
                    year:param.year,
                    month:param.month,
                    vouchtype:param.vouchtype,
                    vouchid:param.vouchid,
                }
                that.$http.urlpost('/CashReady/fillVouch', parm, function(res) {
                    if(res.Success == 1){
                        that.handleData(res.DataContent)
                    }
                });
            },
            // 结转本年利润，显示凭证
            getVouch_carryplnew(param){
                let that = this
                that.isEdit = 1
                let parm = {
                    "会计年度": param.year,
                    "会计期间": param.month
                }
                that.$http.urlpost('/CarryPLNew/CarryPLNewClick', parm, function(res) {
                    if (res.Success == 1) {
                        that.handleData(res.DataContent)
                    }
                });
            },
            // 结转制造费用，生成凭证
            getVouch_carrycostnew(param){
                let that = this
                that.isEdit = 1
                let parm = {
                    "会计年度": param.year,
                    "会计期间": param.month,
                    "List": param.list
                }
                that.$http.urlpost('/CarryCostNew/CarryCostNewClick',parm , function(res) {
                    if (res.Success == 1) {
                        that.handleData(res.DataContent)
                    }
                });
            },
            //获取合计数据
            getSummaryData() {
                const columns = this.$refs.singleTablemb.getColumns(); // 获取列信息
                const data = this.dataTemplate; // 获取表格数据

                const summaryData = {};

                columns.forEach((column) => {
                    const field = column.property;
                    if (['借方金额','贷方金额'].includes(field)) {
                        summaryData[field] = data.reduce((sum, row) =>
                            sum + Number((undefined == row[field]|| '' == row[field])?0:row[field])
                        , 0);
                    }
                });

                return summaryData;
            },
            clicktemplate(row){
                let that = this
                console.log(row)

            },
            //上一张凭证
            prevOrNext(val){
                let that = this
                let parm = {
                    year: that.$root.AccFirstYear,
                    month: that.$root.AccFirstMonth,
                    会计年度:that.templateHead['会计年度'],
                    会计期间:that.templateHead['会计期间'],
                    凭证类别:that.templateHead['凭证类别'],
                    凭证编号:that.templateHead['凭证编号'],
                    type: val
                }
                that.$http.urlpost('/VouchBrower/getPrevOrNextVouchData', parm, function(res) {
                    if(res.Success == 1){
                        that.handleData(res.DataContent)
                    }
                });
            },
            //打印
            print(){
                let that = this
                let parm = {
                    po_no:that.templateHead['会计年度'] + '.' + that.templateHead['会计期间'] + '/' + that.$processdata.subStr(that.templateHead['凭证类别'],'.',true)+'|'+that.templateHead['凭证编号'],
                    TemplateName:'1单张凭证打印.xlsx',
                    LangType:that.$processdata.getLang(),
                    file_type:0
                }
                that.$http.urlpost('/Print/WWFPrint', parm, function(res) {
                    if(res.Success == 1){
                        let hrefurl = res.Key;
                        window.open(hrefurl);
                    }
                });
            },
            //处理凭证数据
            handleData(data){
                let that = this
                if(data.length > 0){
                    that.dataTemplate=[]
                    let head = data[0]
                    that.templateHead['会计年度'] = head['会计年度']
                    that.templateHead['会计期间'] = head['会计期间']
                    that.templateHead['制单日期'] = head['日期']
                    that.templateHead['凭证类别'] = head['凭证类别']
                    that.templateHead['凭证编号'] = head['凭证编号']
                    that.templateHead['附件张数'] = head['附件']
                    that.templateHead['支付日期'] = ''
                    that.templateHead['支付方式'] = head['支付方式']
                    that.templateHead['票号'] = head['票号']
                    that.templateHead['经手人'] = head['经手人']
                    that.templateHead['原始处理号'] = head['原始处理号']
                    that.templateHead['物料处理号'] = head['物料处理号']
                    that.templateHead['凭单号'] = head['凭单号']
                    that.templateHead['凭单序号'] = head['凭单序号']
                    that.templateHead['备注'] = head['备注']
                    that.templateHead['收付类别'] = head['收付类别']
                    that.templateHead['发票号'] = head['发票号']
                    that.templateHead['制单人'] = head['制单']
                    that.templateHead['审核人'] = head['审核']
                    that.templateHead['记帐人'] = head['记帐']
                    that.templateHead['打印人'] = head['打印']
                    that.styleData['资产'] = false
                    that.styleData['供货商'] = false
                    that.styleData['客户'] = false
                    that.styleData['数量'] = false
                    that.styleData['外币'] = false
                    for(let i = 0;i<data.length;i++){
                        that.dataTemplate = [...that.dataTemplate,{
                            摘要:'',
                            会计科目:'',
                            固定资产:'',
                            供货商:'',
                            客户:'',
                            单位码1:'',
                            单位码2:'',
                            单位码3:'',
                            单位码4:'',
                            数量:'',
                            单价:'',
                            币种:'',
                            外币:'',
                            汇率:'',
                            借方金额:'',
                            贷方金额:'',
                            序号:'',
                        }]
                        if(that.styleData['资产'] == false && !that.$limits.fnIsEmpty(data[i]['资产科目编码'])){
                            that.styleData['资产'] = true
                        }
                        if(that.styleData['供货商'] == false && !that.$limits.fnIsEmpty(data[i]['供货商编码'])){
                            that.styleData['供货商'] = true
                        }
                        if(that.styleData['客户'] == false && !that.$limits.fnIsEmpty(data[i]['客户编码'])){
                            that.styleData['客户'] = true
                        }
                        if(that.styleData['数量'] == false && (!that.$limits.fnIsEmpty(data[i]['借方数量']) || !that.$limits.fnIsEmpty(data[i]['贷方数量'] ))){
                            that.styleData['数量'] = true
                        }
                        if(that.styleData['外币'] == false && (!that.$limits.fnIsEmpty(data[i]['借方外币']) || !that.$limits.fnIsEmpty(data[i]['贷方外币'] ))){
                            that.styleData['外币'] = true
                        }
                        that.dataTemplate[i]['摘要']=data[i]['摘要']
                        that.dataTemplate[i]['会计科目']=data[i]['科目编码']
                        that.dataTemplate[i]['固定资产'] = (data[i]['资产科目编码'] == null || data[i]['资产科目编码'].length == 0)?'':data[i]['资产科目编码'] + '.' + data[i]['资产完整科目名称']
                        that.dataTemplate[i]['供货商'] = (data[i]['供货商编码'] == null || data[i]['供货商编码'].length == 0)?'':data[i]['供货商编码'] + '.' + data[i]['供货商名称']
                        that.dataTemplate[i]['客户'] = (data[i]['客户编码'] == null || data[i]['客户编码'].length == 0)?'':data[i]['客户编码']
                        that.dataTemplate[i]['单位码1'] = (data[i]['单位码1'] == null || data[i]['单位码1'].length == 0)?'':data[i]['单位码1'] + '.' + data[i]['单位码1描述']
                        that.dataTemplate[i]['单位码2'] = (data[i]['单位码2'] == null || data[i]['单位码2'].length == 0)?'':data[i]['单位码2'] + '.' + data[i]['单位码2描述']
                        that.dataTemplate[i]['单位码3'] = (data[i]['单位码3'] == null || data[i]['单位码3'].length == 0)?'':data[i]['单位码3'] + '.' + data[i]['单位码3描述']
                        that.dataTemplate[i]['单位码4'] = (data[i]['单位码4'] == null || data[i]['单位码4'].length == 0)?'':data[i]['单位码4'] + '.' + data[i]['单位码4描述']
                        that.dataTemplate[i]['数量'] = (parseFloat(data[i]['借方数量'] == null ? 0 :data[i]['借方数量']) + parseFloat(data[i]['贷方数量']) == null ? 0 :data[i]['贷方数量']) == 0?'':(parseFloat(data[i]['借方数量'] == null ? 0 :data[i]['借方数量']) + parseFloat(data[i]['贷方数量']) == null ? 0 :data[i]['贷方数量'])
                        that.dataTemplate[i]['单价'] = data[i]['单价']==0?'':data[i]['单价']
                        that.dataTemplate[i]['币种'] = data[i]['币种']
                        that.dataTemplate[i]['外币'] = (parseFloat(data[i]['借方外币'])  + parseFloat(data[i]['贷方外币']))==0?'':(parseFloat(data[i]['借方外币'])  + parseFloat(data[i]['贷方外币']))
                        that.dataTemplate[i]['汇率'] = data[i]['汇率']==0?'':data[i]['汇率']
                        that.dataTemplate[i]['借方金额'] = data[i]['借方金额']==0?'':that.preciseRoundToTwo(parseFloat(data[i]['借方金额']))
                        that.dataTemplate[i]['贷方金额'] = data[i]['贷方金额']==0?'':that.preciseRoundToTwo(parseFloat(data[i]['贷方金额']))
                        that.dataTemplate[i]['序号']=data[i]['序号']
                    }
                    that.authority();
                }
            },
            preciseRoundToTwo(num) {
                // 使用 Number.EPSILON 解决浮点数精度问题
                return (Math.round((Number(num) + Number.EPSILON) * 100) / 100).toFixed(2);
            },
            //单张审核
            passVouch(){
                let that = this
                let arr = []
                arr.push({
                    凭证类别:that.$processdata.subStr(that.templateHead['凭证类别'],'.',true),
                    凭证编号:that.templateHead['凭证编号'],
                    记帐: that.templateHead['记帐人'],
                    审核:that.templateHead['审核人'],
                })
                let parm = {
                    year: that.templateHead['会计年度'],
                    month: that.templateHead['会计期间'],
                    vouchtype:that.$processdata.subStr(that.templateHead['凭证类别'],'.',true),
                    vouchid:that.templateHead['凭证编号'],
                    list: arr
                }
                that.$http.urlpost('/VouchBrower/passVouch', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        let parm1 = {
                            year: that.templateHead['会计年度'],
                            month: that.templateHead['会计期间'],
                            vouchtype:that.$processdata.subStr(that.templateHead['凭证类别'],'.',true),
                            vouchid:that.templateHead['凭证编号'],
                            type:3,
                        }
                        that.getVouch(parm1)
                    }
                });
            },
            //单张弃审
            unPassVouch(){
                let that = this
                let arr = []
                arr.push({
                    凭证类别:that.$processdata.subStr(that.templateHead['凭证类别'],'.',true),
                    凭证编号:that.templateHead['凭证编号'],
                    记帐: that.templateHead['记帐人'],
                    审核:that.templateHead['审核人'],
                })
                let parm = {
                    year: that.templateHead['会计年度'],
                    month: that.templateHead['会计期间'],
                    vouchtype:that.$processdata.subStr(that.templateHead['凭证类别'],'.',true),
                    vouchid:that.templateHead['凭证编号'],
                    list: arr
                }
                that.$http.urlpost('/VouchBrower/unPassVouch', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        let parm1 = {
                            year: that.templateHead['会计年度'],
                            month: that.templateHead['会计期间'],
                            vouchtype:that.$processdata.subStr(that.templateHead['凭证类别'],'.',true),
                            vouchid:that.templateHead['凭证编号'],
                            type:3,
                        }
                        that.getVouch(parm1)
                    }
                });
            },
            //自动找平
            balance(){
                let that = this
                if(that.templateHead['审核人'] != '' || that.templateHead['记帐人'] != ''){
                    return
                }
                that.dataTemplate[that.selectIndex]['贷方金额'] = ''
                that.dataTemplate[that.selectIndex]['借方金额'] = ''
                let sum_j = 0
                let sum_d = 0
                for(let i=0;i<that.dataTemplate.length;i++){
                    sum_j = sum_j + parseFloat(that.dataTemplate[i]['借方金额'] == ''?0:that.dataTemplate[i]['借方金额'])
                    sum_d = sum_d + parseFloat(that.dataTemplate[i]['贷方金额'] == ''?0:that.dataTemplate[i]['贷方金额'])
                }
                const difference = sum_j - sum_d
                if(difference>0){
                    that.dataTemplate[that.selectIndex]['贷方金额'] = Math.abs(difference)
                    that.dataTemplate = [...that.dataTemplate]
                } else {
                    that.dataTemplate[that.selectIndex]['借方金额'] = Math.abs(difference)
                    that.dataTemplate = [...that.dataTemplate]
                }

            },
            //借、贷方金额对调
            changeLend(){
                let that = this
                console.log(that.dataTemplate[that.selectIndex])
                if(that.templateHead['审核人'] != '' || that.templateHead['记帐人'] != ''){
                    return
                }
                if(that.$limits.fnIsEmpty(that.dataTemplate[that.selectIndex]['借方金额'])){
                    that.dataTemplate[that.selectIndex]['借方金额'] = that.dataTemplate[that.selectIndex]['贷方金额']
                    that.dataTemplate[that.selectIndex]['贷方金额'] = ''
                } else {
                    that.dataTemplate[that.selectIndex]['贷方金额'] = that.dataTemplate[that.selectIndex]['借方金额']
                    that.dataTemplate[that.selectIndex]['借方金额'] = ''
                }
                that.dataTemplate = [...that.dataTemplate]
            },
            //现金流量数据准备
            fillToVouch(){
                let that = this
                let parm = {
                    序号:'',
                    凭证序号:that.templateHead['会计年度'] + '.' + that.templateHead['会计期间'] + '/' + that.$processdata.subStr(that.templateHead['凭证类别'],'.',true)+'|'+that.templateHead['凭证编号'],

                    凭证索引号: that.$processdata.getVouchIndex(that.templateHead['会计年度'],that.templateHead['会计期间'],that.$processdata.subStr(that.templateHead['凭证类别'],".",true),that.templateHead['凭证编号']),
                    会计年度:that.templateHead['会计年度'],
                    会计期间:that.templateHead['会计期间'],
                    日期:that.templateHead['制单日期'],
                    凭证类别:that.$processdata.subStr(that.templateHead['凭证类别'],'.',true),
                    凭证编号:that.templateHead['凭证编号'],
                    附件:that.templateHead['附件张数'],
                    科目编码:that.$processdata.subStr(that.dataTemplate[0]['会计科目'],'.',true),
                    资产科目编码:'',
                    单位码1:that.dataTemplate[0]['单位码1'],
                    单位码2:that.dataTemplate[0]['单位码2'],
                    单位码3:that.dataTemplate[0]['单位码3'],
                    单位码4:that.dataTemplate[0]['单位码4'],
                    供货商编码:that.dataTemplate[0]['供货商'],
                    客户编码:that.dataTemplate[0]['客户'],
                    摘要:that.dataTemplate[0]['摘要'],
                    方向:that.$limits.fnIsEmpty(that.dataTemplate[0]['借方金额'])?'贷':'借',
                    单价:that.dataTemplate[0]['单价'],
                    借方数量:that.dataTemplate[0]['借方金额'] == 0?0:that.dataTemplate[0]['数量'],
                    贷方数量:that.dataTemplate[0]['借方金额'] == 0?that.dataTemplate[0]['数量']:0,
                    外币币种:that.dataTemplate[0]['币种'],
                    汇率:that.dataTemplate[0]['汇率'],
                    借方外币:that.dataTemplate[0]['借方金额'] == 0?0:that.dataTemplate[0]['外币'],
                    贷方外币:that.dataTemplate[0]['借方金额'] == 0?that.dataTemplate[0]['外币']:0,
                    "借方金额": that.dataTemplate[0]['借方金额'],
                    "贷方金额": that.dataTemplate[0]['贷方金额'],
                    支付日期:that.templateHead['支付日期'],
                    支付方式:that.templateHead['支付方式'],
                    票号:that.templateHead['票号'],
                    经手人:that.templateHead['经手人'],
                    原始处理号:that.templateHead['原始处理号'],
                    物料处理号:that.templateHead['物料处理号'],
                    凭单号:that.templateHead['凭单号'],
                    凭单序号:that.templateHead['凭单序号'],
                    收付类别:that.templateHead['收付类别'],
                    发票号:that.templateHead['发票号'],
                    制单:that.templateHead['制单人'],
                    审核:that.templateHead['审核人'],
                    记帐:that.templateHead['记帐人'],
                    打印:that.templateHead['打印人'],
                    反冲:false,
                    备注:that.templateHead['备注'],
                    RowPointer:'',
                    Company_Ref: that.userData.Site_Ref,
                    IsEdit: that.isEdit,
                    会计科目:that.dataTemplate[0]['会计科目'],
                    客户:that.dataTemplate[0]['客户'],
                    供货商: that.dataTemplate[0]['供货商'],
                    固定资产: that.dataTemplate[0]['固定资产'],
                    数量:that.dataTemplate[0]['数量'],
                    币种: that.dataTemplate[0]['币种'],
                    外币:that.dataTemplate[0]['外币']
                }
                that.$http.urlpost('/Vouch/ReadyCash', parm, function(res) {
                    if (res.Success == 1) {
                        that.visCash = true
                        that.dataCash = res.DataContent
                        that.titleCash = res.UniqueNum
                        that.valCash = res.remark
                    }
                });
            },
            //点击载入模板凭证
            loadVouch(){
                let that = this
                that.getView()
            },
            // 模板凭证数据一览
            getView() {
                let that = this;
                that.loading = true;
                let parm = {}
                that.$http.urlpost('/Basic/General/GetVouchTemplateList', parm, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.visLoadVouch = true
                    }
                });
            },
            //确认回传值
            confirmSelectVouch() {
                let that = this;
                that.isEdit = 1
                if (that.visLoadVouch) {
                    let rows = that.dataSet[that.keySelectIndex];
                    that.editInfo(rows)
                }
            },
            selectVouch(row) {
                let that = this;
                that.keySelectIndex = row.$rowIndex;
            },
            editInfo(row){
                let that = this
                that.isEdit = 1
                let vouchtype = '';
                let vouchtypeall = '';
                let date = that.$processdata.getPeriodDay(localStorage.getItem('AccYear'),localStorage.getItem('AccMonth'))
                for(let i = 0;i<that.vouchtypearr.length;i++){
                    if(that.vouchtypearr[i].Name.indexOf("TJ") !== -1){
                        vouchtypeall = that.vouchtypearr[i].Name
                        console.log(that.vouchtypearr[i].Name)
                        vouchtype = that.$processdata.subStr(that.vouchtypearr[i].Name,'.',true)
                        that.vouchtype = that.vouchtypearr[i].Name
                    }
                }
                vouchtype == ''?that.$processdata.subStr(that.vouchtypearr[0].Name,'.',true):vouchtype
                if(vouchtype == ''){
                    that.vouchtype = that.vouchtypearr[0].Name
                }
                let parm = {
                    year:localStorage.getItem('AccYear'),
                    month:localStorage.getItem('AccMonth'),
                    vouchtype:vouchtype == ''?that.$processdata.subStr(that.vouchtypearr[0].Name,'.',true):vouchtype,
                }
                that.$http.urlpost('/Vouch/getMaxVouchIdEx', parm, function(res) {
                    if (res.Success == 1) {
                        if(res.DataContent){
                            that.templateHead = {
                                会计年度:localStorage.getItem('AccYear'),
                                会计期间:localStorage.getItem('AccMonth'),
                                制单日期:date,
                                凭证类别:that.vouchtype == ''?that.vouchtypearr[0].Name:that.vouchtype,
                                凭证编号:parseInt(res.DataContent) + 1,
                                附件张数:'',
                                支付日期:'',
                                支付方式:'',
                                票号:'',
                                经手人:'',
                                原始处理号:'',
                                物料处理号:'',
                                凭单号:'',
                                凭单序号:'',
                                备注:'',
                                收付类别:'',
                                发票号:'',
                                制单人:that.userData.Login_Name,
                                审核人:'',
                                记帐人:'',
                                打印人:'',
                                // "Text1Text": "", //打印人
                                // "Text9Text": "",//备注
                                // "Text4Text": "",//审核人
                                // "Text5Text": "",//记账人
                                // "Combo1Text": "",//凭证类别
                                // "TDBDate1Value": "",//制单日期
                                // "TDBNumber1Value": '',//凭证编号
                                // "TDBNumber2Value": '',//附件张数
                                // "TDBNumber3Value": localStorage.getItem('AccYear'),//会计年度
                                // "TDBNumber4Value": localStorage.getItem('AccMonth'),//会计期间
                                // "Image1Visible": true,
                            }
                            let parm = {
                                PageIndex: 1,
                                PageSize: 100000,
                                Type: '',
                                Code: '',
                                Name: row['凭证名称'],
                                LangType: that.$processdata.getLang(),
                                //默认子参数
                                Param: {
                                    凭证名称: row['凭证名称']
                                }
                            }
                            that.$http.urlpost('/Basic/General/GetVouchTemplateInfo', parm, function(res) {
                                if (res.Success == 1) {
                                    let data = res.DataContent
                                    that.dataTemplate = []
                                    if(data.length > 0){
                                        let head = data[0]
                                        for(let i=0;i<data.length;i++){
                                            that.dataTemplate = [...that.dataTemplate,{
                                                摘要:data[i]['摘要'],
                                                会计科目:data[i]['科目编码']+'.'+data[i]['完整科目名称']+
                                                    ((data[i]['计量单位'] == null || data[i]['计量单位'].length == 0) ?'':data[i]['计量单位']) +
                                                    ((data[i]['外币币种'] == null || data[i]['外币币种'].length == 0)?'':data[i]['外币币种']),
                                                固定资产:data[i]['固定资产'],
                                                供货商:data[i]['供货商'],
                                                客户:data[i]['客户'],
                                                单位码1:data[i]['单位码1'] == ''?'':data[i]['单位码1']+'.'+data[i]['单位码1描述'],
                                                单位码2:data[i]['单位码2'] == ''?'':data[i]['单位码2']+'.'+data[i]['单位码2描述'],
                                                单位码3:data[i]['单位码3'] == ''?'':data[i]['单位码3']+'.'+data[i]['单位码3描述'],
                                                单位码4:data[i]['单位码4'] == ''?'':data[i]['单位码4']+'.'+data[i]['单位码4描述'],
                                                数量:data[i]['数量']==undefined?'':data[i]['数量'],
                                                单价:data[i]['单价']==undefined?'':data[i]['单价'],
                                                币种:data[i]['币种'],
                                                外币:data[i]['外币']==undefined?'':data[i]['外币'],
                                                汇率:data[i]['汇率']==undefined?'':data[i]['汇率'],
                                                借方金额:data[i]['借方金额']==0?'':data[i]['借方金额'],
                                                贷方金额:data[i]['贷方金额']==0?'':data[i]['贷方金额'],
                                                序号:data[i]['序号'],
                                            }]
                                        }
                                    }
                                    that.visLoadVouch = false
                                    that.authority()
                                }
                            });
                        }
                    }
                });
            },
            //点击现金流量弹窗单元格
            clickcash(row){
                 let that = this
                 that.selectCashIndex = row.$index
                 that.selectcashCell = row.column.property
            },
            //自动填入
            autoFill(){
                let that = this
                if(that.selectcashCell != '流入金额' && that.selectcashCell != '流出金额'){
                    return
                } else {
                    if(that.selectcashCell == '流入金额' ){
                        that.dataCash[that.selectCashIndex]['流入金额'] = that.valCash
                    } else {
                        that.dataCash[that.selectCashIndex]['流出金额'] = -that.valCash
                    }
                }
            },
            //现金流量保存
            saveCash(){
                let that= this
                let parm = that.dataCash
                that.$http.urlpost('/Vouch/ReadySave', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                        that.visCash = false
                    }
                });
            },
            //余额
            surplus(){
                let that = this
                let parm = {
                    会计年度:that.templateHead['会计年度'],
                    会计期间:that.templateHead['会计期间'],
                    科目编码:that.dataTemplate[that.selectIndex]['会计科目'].split('.')[0],
                    单位码1:that.dataTemplate[that.selectIndex]['单位码1'],
                    单位码2:that.dataTemplate[that.selectIndex]['单位码2'],
                    单位码3:that.dataTemplate[that.selectIndex]['单位码3'],
                    单位码4:that.dataTemplate[that.selectIndex]['单位码4'],
                    供货商编码:that.dataTemplate[that.selectIndex]['供货商'],
                    客户编码:that.dataTemplate[that.selectIndex]['客户'],
                }
                that.$http.urlpost('/Vouch/SubjectInfoEx', parm, function(res) {
                    if (res.Success == 1) {
                        //that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        MessageBox.alert(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[30508]'), {
                            confirmButtonText: that.$t('getapi[30506]')
                        });
                    }
                });
            },

            /*键盘键入事件*/
            handleKeyDown(event) {
                if(this.currentKeyboardEventTarget  === 'page'){
                    const { key } = event;
                    switch (key) {
                        case 'ArrowLeft':
                            this.moveFocus(0, -1); // 左移
                            break;
                        case 'ArrowRight':
                            this.moveFocus(0, 1); // 右移
                            break;
                        case 'ArrowUp':
                            this.moveFocus(-1, 0); // 上移
                            break;
                        case 'ArrowDown':
                            this.moveFocus(1, 0); // 下移
                            break;
                        case ' ':
                            this.enter();
                            break;
                        case 'Enter':
                            this.showDialog();
                            break;
                        default:
                            return; // 忽略其他按键
                    }
                    event.preventDefault(); // 阻止默认行为
                } else if(this.currentKeyboardEventTarget  === 'modal_loadvouch'){
                    const { key } = event;
                    if(key == 'ArrowUp'){
                        let refsElTable = this.$refs.singleTable;
                        this.keySelectIndex--;
                        if (this.keySelectIndex < 0) this.keySelectIndex = 0;
                        refsElTable.setCurrentRow(this.dataSet[this.keySelectIndex]);
                    } else if(key == 'ArrowDown'){
                        let refsElTable = this.$refs.singleTable;
                        this.keySelectIndex++;
                        if (this.keySelectIndex > this.dataSet.length - 1) this.keySelectIndex = this.dataSet.length - 1;
                        refsElTable.setCurrentRow(this.dataSet[this.keySelectIndex]);
                    } else if(key == 'Enter'){
                        this.closeModal()
                        this.confirmSelectVouch();
                    }
                }
            },
            // 移动焦点
            moveFocus(rowDelta, colDelta) {
                const newRowIndex = this.currentRowIndex + rowDelta;
                const newColIndex = this.currentColIndex + colDelta;
                // 边界检查
                if (
                    newRowIndex >= 0 &&
                    newRowIndex < this.dataTemplate.length &&
                    newColIndex >= 0 &&
                    newColIndex < this.$refs.singleTablemb.columns.length
                ) {
                    this.currentRowIndex = newRowIndex;
                    this.currentColIndex = newColIndex;
                    this.focusCell(newRowIndex, newColIndex);
                }
            },
            // 聚焦到指定单元格
            focusCell(rowIndex, colIndex) {
                const table = this.$refs.singleTablemb;
                const row = table.$el.querySelectorAll('.el-table__body-wrapper tbody tr')[rowIndex];
                if (row) {
                    const cell = row.querySelectorAll('.cell')[colIndex];
                    if (cell) {
                        cell.tabIndex = 0; // 使单元格可聚焦
                        cell.focus(); // 聚焦到单元格
                    }
                }
            },
            // 处理单元格点击事件
            handleCellClick(row, column, cell) {
                let that = this
                that.selectIndex = row.index
                that.selectrow = row
                const rowIndex = this.dataTemplate.indexOf(row);
                const colIndex = this.$refs.singleTablemb.columns.indexOf(column);
                this.currentRowIndex = rowIndex;
                this.currentColIndex = colIndex;
                //that.focusCell(rowIndex, colIndex);
            },
            enter(){
                const table = this.$refs.singleTablemb;
                const row = table.$el.querySelectorAll('.el-table__body-wrapper tbody tr')[this.currentRowIndex];
                if (row) {
                    const cell = row.querySelectorAll('.cell')[this.currentColIndex];
                    const inputElement = cell.querySelector('input')
                    const textareaElement = cell.querySelector('textarea')
                    if (inputElement) {
                        inputElement.click()
                        inputElement.focus(); // 聚焦到单元格
                    }
                    if(textareaElement){
                        textareaElement.click()
                        textareaElement.focus(); // 聚焦到单元格
                    }
                }
            },
            showDialog(){
                const table = this.$refs.singleTablemb;
                const row = table.$el.querySelectorAll('.el-table__body-wrapper tbody tr')[this.currentRowIndex];
                if (row) {
                    const cell = row.querySelectorAll('.cell')[this.currentColIndex];
                    const inputElement = cell.querySelector('input')
                    const textareaElement = cell.querySelector('textarea')
                    if (inputElement) {
                        if (table && this.currentColIndex !== null) {
                            const columns = table.columns; // 获取列配置
                            if (columns && columns[this.currentColIndex]) {
                                let columnProp = columns[this.currentColIndex].property; // 获取列属性名称
                                if(columnProp == '单位码1'){
                                    this.selectUnitcd1_(this.currentRowIndex)
                                } else if(columnProp == '单位码2'){
                                    this.selectUnitcd2_(this.currentRowIndex)
                                } else if(columnProp == '单位码3'){
                                    this.selectUnitcd3_(this.currentRowIndex)
                                } else if(columnProp == '单位码4'){
                                    this.selectUnitcd4_(this.currentRowIndex)
                                } else if(columnProp == '供货商'){
                                    this.selectVend_(this.currentRowIndex)
                                } else if(columnProp == '客户'){
                                    this.selectCust_(this.currentRowIndex)
                                }
                            }
                        }
                    }
                    if(textareaElement){
                        if (table && this.currentColIndex !== null) {
                            const columns = table.columns; // 获取列配置
                            if (columns && columns[this.currentColIndex]) {
                                let columnProp = columns[this.currentColIndex].property; // 获取列属性名称
                                if(columnProp == '会计科目'){
                                    this.selectSubject_(this.currentRowIndex)
                                }
                            }
                        }
                    }
                }
            },
            // 粘贴
            keyPaste(event) {
                let that = this;
                if ((this.$route.name == this.$options.name) && (that.visLoadVouch == false) && (that.visCash == false)) {
                    event.preventDefault();

                    // 获取剪贴板数据
                    const clipboardData = event.clipboardData || window.clipboardData;
                    const pastedData = clipboardData.getData('text');
                    if (!pastedData) return;

                    // 解析Excel数据(兼容各种换行和制表符情况)
                    const rows = pastedData
                        .replace(/\r\n?/g, '\n')  // 统一换行符
                        .split('\n')
                        .map(function (row) {
                            return row.split('\t').map(function (cell) {
                                return cell.trim();
                            });
                        })
                        .filter(function (row) {
                            return row.some(function (cell) {
                                return cell;
                            });
                        });
                    if (rows.length === 0) return;

                    // 获取表格列信息
                    const columns = this.$refs.singleTablemb.columns;
                    const columnProps = columns.map(col => col.property).filter(Boolean);
                    // 获取当前选中位置
                    /*const selection = window.getSelection().toString();
                    let startRow = this.dataTemplate.length;
                    if (selection) {
                        for (let i = 0; i < this.dataTemplate.length; i++) {
                            if (JSON.stringify(this.dataTemplate[i]).indexOf(selection) !== -1) {
                                startRow = i;
                                break;
                            }
                        }
                    }*/

                    // 处理粘贴数据
                    for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
                        const targetRow = that.selectIndex + rowIndex;

                        // 确保行存在
                        if (targetRow >= this.dataTemplate.length) {
                            this.dataTemplate.push(this.createEmptyRow(columnProps));
                        }

                        // 计算可粘贴的列数
                        const pasteCols = Math.min(
                            rows[rowIndex].length,
                            16 - this.currentColIndex
                        );
                        // 填充数据
                        for (let colIndex = 0; colIndex < pasteCols; colIndex++) {
                            const targetCol = this.currentColIndex + colIndex;
                            if (targetCol < 16) {
                                const propName = columnProps[targetCol];
                                this.$set(this.dataTemplate[targetRow], propName, rows[rowIndex][colIndex]);
                            }
                        }
                    }
                }
            },
            createEmptyRow(columnProps) {
                // 创建包含16列的空行
                var emptyRow = {};
                columnProps.forEach(prop => {
                    emptyRow[prop] = '';
                });
                console.log(emptyRow)
                return emptyRow;
            },
            //选择会计科目
            selectSubjectTree(){
                let that = this
                that.$refs.subjecttree.showSubject('');
            },
            //获取会计科目
            getSubjectTree(data){
                let that = this
                that.dataTemplate[that.selectIndex]['会计科目'] = data['科目编码']+'.'+data['完整科目名称']
            },
            //选择摘要
            selectAbstract(){
                let that = this
                that.$refs.abstract.showAbstract();
            },
            //获取会计科目
            getAbstract(data){
                let that = this
                console.log(data)
                that.dataTemplate[that.selectIndex]['摘要'] = data['摘要']
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
        margin-bottom: 5px!important;
    }
    .pztitle{
        padding:3px 0px 3px 0px;
        background-color: #1b1b6f;
        color: #ffffff;
        text-align: center;
    }
    /* 移除鼠标移入效果 */
    /deep/.el-table__body tr:hover > td {
        background-color: transparent !important; /* 移除鼠标移入时的背景色 */
    }
    /* 使单元格聚焦时显示边框 */
    /deep/.cell{
        height:100%;
    }
    /deep/.cell:focus {
        outline: none;
        background-color: #b9d7f8; /* 修改背景色 */
        border:1px solid #0188fb;
        input{
            /*border-color: #409eff; !* 修改边框颜色 *!
            box-shadow: 0 0 5px rgba(64, 158, 255, 0.5); !* 添加阴影效果 *!*/
            background-color: #b9d7f8; /* 修改背景色 */
        }
        textarea{
            /*border-color: #409eff; !* 修改边框颜色 *!
            box-shadow: 0 0 5px rgba(64, 158, 255, 0.5); !* 添加阴影效果 *!*/
            background-color: #b9d7f8; /* 修改背景色 */
        }
    }
    /deep/.noborder{
        input{
            border: 0px;
        }
        textarea{
            border: 0px;
        }
    }
    /deep/.noborder_fontred{
        input{
            border: 0px;
            color:red!important
        }
        textarea{
            border: 0px;
        }
    }

    /deep/.el-table th.el-table__cell>.cell  {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
    }
</style>
